import { NgModule, Optional, Self } from '@angular/core';
import { routerReducer, RouterStateSerializer, StoreRouterConnectingModule, RouterReducerState, NavigationActionTiming } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { MergedRouterStateSerializer } from './merged-route-serialzer';
import { Router } from '@angular/router';
import { MergedRoute } from './merged-route';

export const routerStateConfig = {
  stateKey: 'router',
  navigationActionTiming: NavigationActionTiming.PreActivation,
};

const initialState: RouterReducerState<MergedRoute> = {
  state: null,
  navigationId: -1
};

@NgModule({
  imports: [
    StoreModule.forFeature(routerStateConfig.stateKey, routerReducer, { initialState }),
    StoreRouterConnectingModule.forRoot(routerStateConfig),
  ],
  exports: [
    StoreModule,
    StoreRouterConnectingModule
  ],
  providers: [
    {
      provide: RouterStateSerializer,
      useClass: MergedRouterStateSerializer,
    }
  ]
})
export class NgrxRouterStoreModule {

  constructor(@Self() @Optional() router: Router) {
    if (router) {
      console.log('All good, NgrxRouterStoreModule');
    } else {
      console.error('All good, NgrxRouterStoreModule must be imported in the same same level as RouterModule');

    }
  }

}
